module.exports = __webpack_public_path__ + "img/formTop.8fb58ba6.jpg";